/**
 * 创建人：严箫
 * 时间：2023-03-29
 * 描述：导出表格
 * 使用说明: 
 * 更新记录:  
 */
import { Component, OnInit, Output, EventEmitter, ViewChild, Input, ElementRef } from '@angular/core';
import { SwModalframeComponent } from 'src/app/librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { isNullOrUndefined } from 'util';
import { SwExportService } from 'src/app/librarys/serves/public/sw-export.service';
declare var $: any;

@Component({
  selector: 'app-sw-table-export',
  templateUrl: './sw-table-export.component.html',
  styleUrls: ['./sw-table-export.component.css']
})
/**
 * 格式如下：
 * var title = [{descript: this.Data.name1,name: 'name'},{descript: this.Data.name2,name: 'value'}]
 * let param = {datasTitle: title, datas: this.Datas,headerLogo:"活动预约分析数据",printEcharts:'.graph',isHiddenEcharts:false}
 *  this.create.createModal(SwTablePrintComponent,param)
 * 
 * 说明：printEcharts、isHiddenEcharts可传可不传     
 * 1.printEcharts 当有特殊统计图时，可加id标识分辨  
 * 2.isHiddenEcharts 默认打印统计图片   当为true时,不打印统计图，只打印表格数据
*/
export class SwTableExportComponent implements OnInit {
  @ViewChild('modal') modal: SwModalframeComponent; //弹出层组件
  @Input() param: any;
  @Output() callback = new EventEmitter(); //抛出事件
  /**
   * headerLogo 预览表格弹框的标题 初始值为打印 参数可传，也可不传
   */
  headerLogo: string = "导出";
  /**
  * datasTitle 预览表格和打印表格的表头数据 如 [{descript: '文物类别',name: 'name'},{descript: '数量',name: 'count'}]
  * 
  */
  datasTitle: any = [];
  /**
 * datas 预览表格的表格数据 如 [{name: '金银器',count: '0'},]
 * 
 */
  datas: any = [];

  isCommon:boolean = false;//是否是通用导出
  dataList:any=[];//统计接口返回的数据
  colList :any=[];//通用导出的数据列
  constructor(
    private exportService: SwExportService,
  ) {

  }

  ngOnInit() {
    if (this.param['headerLogo']) {
      this.headerLogo = this.param['headerLogo']
    }
    this.datasTitle = this.param['datasTitle'];
    this.datas = this.param['datas'];
    this.isCommon = this.param['isCommon'] ? this.param['isCommon']:false
    if(this.isCommon){
      this.dataList = this.param['dataList'];
      this.colList = this.param['colList'];
    }
  }

  /**
   * 导出
   */
  ClickExport() {
    
    const url = this.param['url'];
    const param = this.param['param'];
    const fileName = this.param['fileName'];
    if (!isNullOrUndefined(param) && param != "") {
      this.exportService.PostExportExcel(url, param, fileName);
    } else {
      this.exportService.getExportExcel(url, fileName);
    }
   
  }
  ClickExport2() {
    
    const url = this.param['url'];
    let param = {
      dataList:this.dataList,
      colList:this.colList
    }
    //const param = this.param['param'];
    const fileName = this.param['fileName'];
    this.exportService.PostExportExcel(url, param, fileName);
   
  }
  /**
   * 取消
   */
  cancelCancel() {
    $("#body").find('.print-iframe').remove()
    this.callback.emit()
  }



}